import coreApiClient from "@/providers/core-api/CoreApi"
const resourceName = "/v1/workspaces"

export default {
  readWorkspaceInfo(workspaceId) {
    return coreApiClient.sendRequest("get", `${resourceName}/${workspaceId}`, {})
  },
  getAvailabilities(workspaceId, startDate, endDate) {
    let payload = {
      "start_date": startDate,
      "end_date": endDate
    }

    return coreApiClient.sendRequest("get", `${resourceName}/${workspaceId}/workshop-availabilities`, payload)
  },
  getAvailableReasons(workspaceId) {
    return coreApiClient.sendRequest("get", `${resourceName}/${workspaceId}/workshop-actions`, {})
  },
  storeAppointment(workspaceId, dataObject) {
    let payload = {
      date: dataObject.date,
      actions: dataObject.actions,
      plate_number: dataObject.plateNumber,
      firstname: dataObject.firstname,
      lastname: dataObject.lastname,
      email: dataObject.email,
      phone_number: dataObject.phoneNumber,
      workspace_id: workspaceId
    }

    return coreApiClient.sendRequest("post", "/v1/workshop-appointments", payload)
  }
}
